import { use } from "i18next";
import { initReactI18next } from "react-i18next";
import * as en from "@/src/common/locales/en";
import * as fr from "@/src/common/locales/fr";

const resources = {
	en,
	fr,
};

export const LANGUAGES = {
	en: "English",
	fr: "Français",
} as const;

export type Language = keyof typeof LANGUAGES;

export const NAMESPACES = {
	common: "common",
	marketing: "marketing",
	auth: "auth",
	admin: "admin",
	invite: "invite",
};

export type Namespace = keyof typeof NAMESPACES;

export const DEFAULT_LANGUAGE: Language = "fr";
export const DEFAULT_NAMESPACE: Namespace = "common";

export const SUPPORTED_LANGUAGES: readonly Language[] = ["fr", "en"];

export function isLanguage(value: string): value is Language {
	return value in LANGUAGES;
}

export function resolveLanguage(value: string | undefined): Language {
	if (value && isLanguage(value)) return value;
	return DEFAULT_LANGUAGE;
}

use(initReactI18next).init({
	resources,
	ns: Object.values(NAMESPACES),
	defaultNS: DEFAULT_NAMESPACE,
	fallbackNS: DEFAULT_NAMESPACE,
	fallbackLng: DEFAULT_LANGUAGE,
	supportedLngs: SUPPORTED_LANGUAGES,
	interpolation: {
		escapeValue: false,
	},
	react: {
		useSuspense: true,
	},
	nsSeparator: ":",
	keySeparator: ".",
	detection: {
		order: ["cookie", "navigator"],
		lookupCookie: "app-locale",
		caches: ["cookie"],
	},
});

export { default } from "i18next";
